import React from 'react';
import { HumanMeanResponse } from '@/api/bol';
import { DeleteConfirmDialog } from '@/components/common/DeleteConfirmDialog';

export interface HumanMeanDeleteDialogProps {
  open: boolean;
  onClose: () => void;
  onConfirm: () => Promise<void>;
  humanMean: HumanMeanResponse | null;
}

export const HumanMeanDeleteDialog: React.FC<HumanMeanDeleteDialogProps> = ({
  open,
  onClose,
  onConfirm,
  humanMean,
}) => {
  return (
    <DeleteConfirmDialog
      open={open}
      onClose={onClose}
      onConfirm={onConfirm}
      itemType="human-mean"
      itemId={humanMean?.id || ''}
    />
  );
};
